/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum KRecommendationBasis {
    KBaseSaturation = "KBaseSaturation",
    IdealKMgKg = "IdealKMgKg"
}

export default KRecommendationBasis;
